<!--
 * @Date: 2022-10-24 16:01:06
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-08-20 12:00:55
 * @FilePath: /nicee-web-tw/src/components/Recharge/tappay-page.vue
 * @Description: tappay支付
-->
<template>
  <div class="tappay-page" v-show="show">
    <div class="card-box" v-if="cardList && cardList.length && !showForm">
      <div
        class="pay-type-list"
        v-for="item of cardList"
        :key="item.id"
        @click="selectTappayCard(item.id)"
      >
        <div class="card-info">
          <img
            class="pay-type-image"
            src="./images/visa.png"
            alt=""
            v-if="item.type === 1"
          />
          <img
            class="pay-type-image"
            src="./images/mastercard.png"
            alt=""
            v-else-if="item.type === 2"
          />
          <img
            class="pay-type-image"
            src="./images/jcb.png"
            alt=""
            v-else-if="item.type === 3"
          />
          <img
            class="pay-type-image"
            src="./images/Amex.png"
            alt=""
            v-else-if="item.type === 5"
          />
          <span class="card-number"> ************{{ item.lastCode }} </span>
        </div>
        <div class="checkbox" :class="{ 'is-check': checkCardId === item.id }">
          <i class="el-icon-check" v-show="checkCardId === item.id"></i>
        </div>
      </div>
      <div class="add-card-btn" @click="addCard()">
        <img class="pay-type-image" src="./images/CREDIT.png" alt="" />
        <span> 添加信用卡 </span>
      </div>
    </div>
    <div class="add-card-box" v-if="showForm">
      <div class="add-card-header" v-if="cardList && cardList.length">
        <span>添加信用卡</span>
        <span class="cancel-btn" @click="showForm = false">取消</span>
      </div>
      <form ref="form">
        <div class="form-group-box">
          <div class="form-group card-number-group">
            <label
              for="card-number"
              class="control-label control-label-card-number"
            >
              <span>卡號</span>
            </label>
            <div class="card-number-box">
              <div class="form-control card-number"></div>
              <div>
                <img class="card-logo" src="./images/visa.png" alt="" />
                <img class="card-logo" src="./images/mastercard.png" alt="" />
                <img class="card-logo" src="./images/Discover.png" alt="" />
                <img class="card-logo" src="./images/Amex.png" alt="" />
              </div>
            </div>
          </div>
          <div class="form-group expiration-date-group">
            <label for="expiration-date" class="control-label">有效期</label>
            <div
              class="form-control expiration-date"
              id="tappay-expiration-date"
            ></div>
          </div>
          <div class="form-group ccv-group">
            <label for="ccv" class="control-label">安全碼</label>
            <div class="form-control ccv" id="form-control-ccv"></div>
          </div>
        </div>

        <div class="remember-box">
          <el-checkbox
            v-model="submitObj.remember"
            shape="square"
          ></el-checkbox>
          <span class="message">我同意記住卡片資訊，以方便下次結帳。</span>
        </div>
        <button class="submit-btn" ref="submitButton" type="submit"></button>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TappayPage',
  props: {
    // 商品价格
    price: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler: function(nVal) {
        if (nVal) {
          this.showPage();
        } else {
          this.closePage();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      show: false, //是否顯示
      isInit: false, // 是否已經初始化sdk
      loading: false,
      submitObj: {
        remember: false, // 是否記住卡片信息
        prime: '', //支付的prime
        cardId: null //银行卡id
      },
      cardList: [],
      checkCardId: null,
      showForm: false
    };
  },
  computed: {},
  mounted() {},
  created() {
    if (!window.TPDirect) {
      require('@/sdk/tappay-v5.13.js');
    }
  },
  methods: {
    // 初始化tappay
    init() {
      if (!this.isInit && this.showForm) {
        console.log('init');
        this.$nextTick(() => {
          this.$refs.form.addEventListener('submit', event => {
            event.preventDefault();
            // Get prime
            TPDirect.card.getPrime(result => {
              this.submitObj.prime = result.card.prime;
              this.submitObj.cardId = null;
              this.submit();
              if (result.status !== 0) {
                alert('get prime error ' + result.msg);
                return;
              }
            });
          });
          TPDirect.setupSDK(
            126179,
            'app_rk7WiBr8Llr4pe5Ewpt1Y2WGxGh3fqQc8JnR20TgHdajAqUOrztVvHuRLguk',
            process.env.VUE_APP_ENV === 'production' ? 'production' : 'sandbox'
          );
          TPDirect.card.setup({
            fields: {
              number: {
                element: '.form-control.card-number',
                placeholder: '**** **** **** ****'
              },
              expirationDate: {
                element: document.getElementById('tappay-expiration-date'),
                placeholder: 'MM / YY'
              },
              ccv: {
                element: document.getElementById('form-control-ccv'),
                placeholder: '後三碼'
              }
            },
            styles: {
              input: {
                color: 'gray'
              },
              'input.ccv': {
                // 'font-size': '16px'
              },
              ':focus': {
                color: 'black'
              },
              '.valid': {
                color: 'green'
              },
              '.invalid': {
                color: 'red'
              },
              '@media screen and (max-width: 400px)': {
                input: {
                  color: 'orange'
                }
              }
            },
            // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
            isMaskCreditCardNumber: true,
            maskCreditCardNumberRange: {
              beginIndex: 6,
              endIndex: 11
            }
          });
          // listen for TapPay Field
          TPDirect.card.onUpdate(update => {
            if (update.canGetPrime) {
              // this.$refs.submitButton.removeAttribute('disabled');
            } else {
              // this.$refs.submitButton.setAttribute('disabled', true);
            }

            // number 欄位是錯誤的
            if (update.status.number === 2) {
              this.setNumberFormGroupToError('card-number-group');
            } else if (update.status.number === 0) {
              this.setNumberFormGroupToSuccess('card-number-group');
            } else {
              this.setNumberFormGroupToNormal('card-number-group');
            }

            if (update.status.expiry === 2) {
              this.setNumberFormGroupToError('expiration-date-group');
            } else if (update.status.expiry === 0) {
              this.setNumberFormGroupToSuccess('expiration-date-group');
            } else {
              this.setNumberFormGroupToNormal('expiration-date-group');
            }

            if (update.status.ccv === 2) {
              this.setNumberFormGroupToError('ccv-group');
            } else if (update.status.ccv === 0) {
              this.setNumberFormGroupToSuccess('ccv-group');
            } else {
              this.setNumberFormGroupToNormal('ccv-group');
            }
          });
          this.isInit = true;
        });
      }
    },
    setNumberFormGroupToError(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-error');
      classList.remove('has-success');
    },
    setNumberFormGroupToSuccess(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-success');
      classList.remove('has-error');
    },
    setNumberFormGroupToNormal(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.remove('has-success');
      classList.remove('has-error');
    },
    // 获取银行卡列表
    async getCardList() {
      try {
        const { data } = await this.$http.get('/payment/tabPay/cardList');
        this.cardList = data || [];
        return true;
      } catch (error) {
        return false;
      }
    },
    // 顯示界面
    async showPage() {
      this.show = true;
      this.loading = true;
      this.submitObj = {
        remember: false,
        prime: '',
        cardId: null
      };
      this.loading = false;
      if (!(this.cardList && this.cardList.length)) {
        await this.getCardList();
      }
      if (!(this.cardList && this.cardList.length)) {
        this.addCard();
      } else {
        this.init();
      }
    },
    // 關閉界面
    closePage() {
      this.show = false;
    },
    // 提交
    submit() {
      this.$emit('submit', this.submitObj);
    },
    handleSubmit() {
      if (this.showForm) {
        this.$refs.submitButton.click();
      } else {
        this.submit();
      }
    },
    // 选择银行卡
    selectTappayCard(id) {
      this.checkCardId = id;
      this.submitObj = {
        cardId: id,
        prime: 'cardToken-' + id
      };
    },
    addCard() {
      this.showForm = true;
      this.checkCardId = null;
      // this.isInit = false;
      this.init();
    }
  }
};
</script>
<style lang="scss">
.tappay-page {
  margin-top: 12px;
  font-size: 14px;
  min-width: 724px;
  .card-box {
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    .pay-type-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e9e9e9;
      height: 60px;
      padding: 0 18px;
      .card-info {
        display: flex;
        align-items: center;
      }
      .card-number {
        display: inline-block;
        padding-left: 14px;
        color: #8c94aa;
      }
      .checkbox {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        justify-content: center;
        &.is-check {
          border: none;
          background: #fed838;
          .el-icon-check {
            color: white;
          }
        }
      }
    }
    .pay-type-image {
      width: 28.75px;
    }
    .add-card-btn {
      display: inline-flex;
      align-items: center;
      height: 60px;
      padding: 0 18px;
      cursor: pointer;
      // img,
      // span {
      //   cursor: pointer;
      // }
    }
  }
  .add-card-box {
    width: 100%;
    background: rgba(232, 234, 238, 0.8);
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    // padding: 0 18px 28px 18px;
    .add-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #222c43;
      height: 56px;
      padding: 0 18px;
      border-bottom: 1px solid #dbdbdb;
      .cancel-btn {
        color: #8c94aa;
        cursor: pointer;
      }
    }
    .form-group-box {
      display: flex;
      align-items: center;
      padding: 18px 18px 0;
    }
    .form-group {
      margin-right: 12px;
      &.last-child {
        margin-right: 0;
      }
    }
    .control-label {
      color: #222c43;
      font-size: 14px;
      margin-bottom: 9px;
      display: inline-block;
    }
    .form-control {
      height: 44px;
      background: rgba(255, 255, 255, 1);
      padding: 0 12px;
      min-width: 143px;
    }
    .card-number-group {
      .control-label-card-number {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .card-number-box {
        padding-right: 10px;
        display: flex;
        align-items: center;
        border: 1px solid rgba(219, 219, 219, 0.8);
        border-radius: 2px;
        justify-content: space-between;
        width: 366px;
        background: rgba(255, 255, 255, 1);
        .form-control {
          width: 240px;
        }
      }
      .card-logo {
        width: 23px;
        margin-left: 2px;
      }
    }
    .remember-box {
      margin-top: 36px;
      color: #636d86;
      padding: 0 18px 18px;
    }
  }
  .submit-btn {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.new-saving {
  .remember-box {
    .el-checkbox__input {
      &.is-checked {
        // background-color: rgb(99, 109, 134);
        .el-checkbox__inner {
          background-color: rgb(99, 109, 134);
          border-color: rgb(99, 109, 134);
          &:hover {
            border-color: rgb(99, 109, 134);
          }
        }
      }
      .el-checkbox__inner {
        &:hover {
          border-color: rgb(99, 109, 134);
        }
      }
    }
  }
}
</style>
